import { UiRenderer } from "@agent/UiRenderer";
import type { UiPayload } from "@agent/uiSchema";
import type { View } from "@views/viewsClient";

/** Display-only: buttons are inert, so `onAction` never fires. */
export const ViewRenderer = ({
  view,
  frameless = false,
}: {
  view: View;
  frameless?: boolean;
}) => {
  const payload: UiPayload = {
    render_id: view.id,
    root: view.root,
    data: view.data,
  };

  return (
    <UiRenderer
      payload={payload}
      storeKey={view.id}
      onAction={() => {}}
      readOnly
      frameless={frameless}
    />
  );
};
